// extracted by mini-css-extract-plugin
export default {"selectTemplate":"SelectTemplate_selectTemplate__-tgKR","buttonContainer":"SelectTemplate_buttonContainer__kNBPR","customSubmitButton":"SelectTemplate_customSubmitButton__HK5JK"};